import React from 'react';
import { useTheme } from 'styled-components';

export const XSvg = (props) => {
  const { width, height, color, box, circle } = props;

  const theme = useTheme();

  if (box) {
    return (
      <svg width={width ?? "14"} height={height ?? "14"} viewBox="0 0 14 14" fill={color ?? window?.settings?.primary_color ?? '#1DBD6B'} xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M3.78 0.332031H9.56C11.82 0.332031 13.3333 1.9187 13.3333 4.2787V9.72603C13.3333 12.0794 11.82 13.6654 9.56 13.6654H3.78C1.52 13.6654 0 12.0794 0 9.72603V4.2787C0 1.9187 1.52 0.332031 3.78 0.332031ZM8.6733 8.99867C8.89997 8.77267 8.89997 8.406 8.6733 8.17934L7.48663 6.99267L8.6733 5.80534C8.89997 5.57934 8.89997 5.206 8.6733 4.97934C8.44663 4.752 8.07997 4.752 7.84663 4.97934L6.66663 6.16534L5.47997 4.97934C5.24663 4.752 4.87997 4.752 4.6533 4.97934C4.42663 5.206 4.42663 5.57934 4.6533 5.80534L5.83997 6.99267L4.6533 8.17267C4.42663 8.406 4.42663 8.77267 4.6533 8.99867C4.76663 9.112 4.91997 9.17267 5.06663 9.17267C5.21997 9.17267 5.36663 9.112 5.47997 8.99867L6.66663 7.81934L7.8533 8.99867C7.96663 9.11934 8.1133 9.17267 8.25997 9.17267C8.4133 9.17267 8.55997 9.112 8.6733 8.99867Z" />
      </svg>
    )
  }


  if (circle) {
    return (
      <svg width={width ?? "12"} height={height ?? "13"} viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 11.5C8.76142 11.5 11 9.26142 11 6.5C11 3.73858 8.76142 1.5 6 1.5C3.23858 1.5 1 3.73858 1 6.5C1 9.26142 3.23858 11.5 6 11.5Z" fill={color ?? "#C1BCF6"} />
        <path d="M7.5 5L4.5 8" stroke="#F3F5F5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M4.5 5L7.5 8" stroke="#F3F5F5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    )
  }

  return (
    <svg width={width ?? "9"} height={height ?? "9"} viewBox="0 0 9 9" fill={color ?? theme?.colour?.primary ?? "#9EACB0"} xmlns="http://www.w3.org/2000/svg">
      <path d="M6.33218 4.46178L8.47928 2.31239C8.99099 1.8023 8.99099 0.973852 8.47928 0.462008C7.96756 -0.049836 7.13932 -0.049836 6.6276 0.462008L4.48051 2.60788L2.33341 0.462008C1.82169 -0.049836 0.991694 -0.049836 0.479978 0.462008C-0.0317375 0.973852 -0.0317375 1.8023 0.479978 2.31239L2.62883 4.46178L0.479978 6.60942C-0.0317375 7.12126 -0.0317375 7.94971 0.479978 8.45979C0.736716 8.7166 1.07083 8.845 1.40669 8.845C1.74256 8.845 2.07667 8.7166 2.33341 8.45979L4.48051 6.31392L6.6276 8.45979C6.88258 8.7166 7.21845 8.845 7.55432 8.845C7.88843 8.845 8.2243 8.7166 8.47928 8.45979C8.99099 7.94971 8.99099 7.12126 8.47928 6.60942L6.33218 4.46178Z" />
    </svg>

  )
}